<template>
    <van-popup v-model="show" class="agreenebt-popup" :lock-scroll="false" :close-on-click-overlay="false">
        <p class="title">{{title}}</p>
        <div class="content" @scroll="scrollChange" ref="content" v-html="content"></div>
        <!-- <p class="wrang-tipx">请滑动协议，确保阅读完整</p> -->
        <van-button
            type="primary"
            class="agreenebtn"
            :color="!isDisabled ? '#6e6f72' : ' linear-gradient(180deg, #F9A1A0 0%, #F46766 100%)'"
            :disabled="!isDisabled"
            @click="submit"
            >
            <!-- {{$t("user.loginTxt")}} -->
            {{!isDisabled?'请上滑看完本协议再同意':'同意本协议'}}
        </van-button>
        
    </van-popup>
</template>

<script>
import { config_protocal_text } from "@/api/user";
export default {
    props:{
        overSubmit:Function
    },
    data () {
        return {
            isBottom:false,
            show:true,
            title:'',
            content:'',
            isDisabled:false,
        }
    },
    
    created(){
        this.getArgeementText();
    },
    mounted () {
        this.$nextTick(()=>{
            // console.log(this.$refs,this.$refs.content.scrollHeight);
            setTimeout(()=>{
                // console.log(this.$refs,this.$refs.content.scrollHeight,7.1 * this.$store.getters.fontSize);
                if(this.$refs.content.scrollHeight <= 14.1 * this.$store.getters.fontSize){
                    // this.isDisabled = true;
                    if(!this.isBottom){
                        this.setIntervalFun();
                    }
                }
            },1000)
        })
    },
    methods:{
        scrollChange(e){
            if(this.$refs.content.offsetHeight + this.$refs.content.scrollTop + 10 >= this.$refs.content.scrollHeight){
                if(!this.isBottom){
                    this.setIntervalFun();
                }
            }
        },
        setIntervalFun(){
            this.isBottom =  true;
            this.isDisabled = true;
        },
        submit(){
            this.overSubmit();
        },
        async getArgeementText(){
            let datadd = {};
            let result = await config_protocal_text(datadd);
            // console.log(result);
            if(result.data.errorCode == 0){
                this.title = result.data.data.title;
                this.content = result.data.data.content;
            }else{
                this.$toast(this.$t("login.agreementfail"));
                this.$router.go(-1);
            }
        }
    }
}
</script>

<style lang="less">
.van-button--disabled.agreenebtn{
    .van-button__text{
        color: #fff;
    }
}
.agreenebt-popup{
    padding: 0.6rem;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0.16rem  0.16rem 0 0;
    transform:unset;
    left: unset;
    top: unset;
    bottom: 0;
    .title{
        font-size: 0.68rem;
        text-align: center;
    }
    .wrang-tipx{
        font-size: 0.48rem;
        margin: 0.3rem 0;
        color: #999;
    }
    .content{
        margin: 0.6rem 0;
        min-height: 14rem;
        box-sizing: border-box;
        max-height: 14rem;
        overflow: auto;
        *{
            word-break: break-all;
            font-size: 0.56rem !important;
        }
    }
    .van-button {
        width: 100%;
        font-size: 0.64rem;
        border-radius: 0.88rem;
        height: 1.76rem;
    }
    
}
</style>